import {APP_INITIALIZER, ApplicationConfig, importProvidersFrom, provideZoneChangeDetection} from '@angular/core';
import {
  InMemoryScrollingFeature,
  InMemoryScrollingOptions,
  provideRouter, ROUTES,
  withInMemoryScrolling
} from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {provideClientHydration, withHttpTransferCacheOptions} from '@angular/platform-browser';
import {environment} from '../environments/environment';
import {LandingService} from './common/services/landing.service';
import {APP_BASE_HREF, registerLocaleData} from '@angular/common';
import localeRu from '@angular/common/locales/ru';
import {apiWithoutTransferCache} from './const';
import {HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi} from '@angular/common/http';
import {SeoService} from './common/services/seo.service';
import {RegionalityService} from './common/services/regionality.service';
import {CommonInterceptor} from './common/interceptors/common.interceptor';
import {DynamicDialogModule} from 'primeng/dynamicdialog';
import {generateRoutes, routes} from './app.routes';

const scrollConfig: InMemoryScrollingOptions = {
  scrollPositionRestoration: 'disabled',
  anchorScrolling: 'disabled',
};

const inMemoryScrollingFeature: InMemoryScrollingFeature = withInMemoryScrolling(scrollConfig);

registerLocaleData(localeRu);

function initRegionService(regionService: RegionalityService) {
  return () => {
    regionService.initialize().toPromise();
  };
}

function initSearchEngineOptimization(seoService: SeoService) {
  return () => seoService.autoUpdateTags();
}


export const appConfig: ApplicationConfig = {
  providers: [
    // {
    //   provide: APP_INITIALIZER,
    //   useFactory: (landingService: LandingService) => () => landingService.initialize(),
    //   deps: [LandingService],
    //   multi: true,
    // },
    // {
    //   provide: APP_BASE_HREF,
    //   useFactory: (landingService: LandingService) => {
    //     const landing = landingService.getLanding();
    //     if (environment.environmentName === 'development') {
    //       return '/';
    //     } else {
    //       // Для stage и release базовый путь корневой
    //       return '/';
    //     }
    //   },
    //   deps: [LandingService],
    // },
    importProvidersFrom([
      DynamicDialogModule,
    ]),
    provideZoneChangeDetection({ eventCoalescing: true }),
    // {
    //   provide: ROUTES,
    //   useFactory: (landingService: LandingService) => generateRoutes(landingService),
    //   deps: [LandingService],
    //   multi: true,
    // },
    provideRouter(routes, inMemoryScrollingFeature),
    provideClientHydration(
      withHttpTransferCacheOptions({
        filter: (req) =>
          req.method === 'GET' &&
          !apiWithoutTransferCache.some((url) => req.url.toLowerCase().includes(url.toLowerCase())),
      })
    ),
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
    provideAnimationsAsync(),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CommonInterceptor,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initRegionService,
      deps: [RegionalityService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initSearchEngineOptimization,
      deps: [SeoService],
      multi: true,
    },
  ]
};
